export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10327.a9c88360.jpg";